import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const bubbles = [
  { role: "ai", text: "Hi, I'm Vera. What's your primary wellness goal right now?" },
  { role: "user", text: "I want to recover faster from training and sleep better." },
  { role: "ai", text: "Got it. How experienced are you with peptide protocols?" },
  { role: "user", text: "Total beginner." },
  { role: "ai", text: "Perfect — I'd start you with BPC-157 for recovery and Epithalon for deeper sleep. ✦" },
];

export default function IntakeMock() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="tracing-beam rounded-[1.75rem] bg-bone p-1"
    >
      <div className="rounded-[1.6rem] bg-bone border border-line overflow-hidden">
        <div className="flex items-center gap-3 px-5 py-4 border-b border-line bg-sand/60">
          <div className="w-9 h-9 rounded-full bg-forest flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={1.5} />
          </div>
          <div>
            <p className="font-semibold text-sm text-ink">Vera</p>
            <p className="text-xs text-forest">AI Wellness Concierge</p>
          </div>
          <span className="ml-auto w-2.5 h-2.5 rounded-full bg-forest animate-pulse" />
        </div>
        <div className="p-5 space-y-3.5 bg-bone">
          {bubbles.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.25 }}
              className={`flex ${b.role === "user" ? "justify-end" : "justify-start"}`}
            >
              <p
                className={`max-w-[80%] text-sm leading-relaxed px-4 py-2.5 rounded-2xl ${
                  b.role === "user"
                    ? "bg-sand text-ink rounded-br-md"
                    : "bg-sage text-forest-dark rounded-bl-md"
                }`}
              >
                {b.text}
              </p>
            </motion.div>
          ))}
        </div>
        <div className="px-5 pb-5">
          <div className="flex items-center gap-2 border border-line rounded-full px-4 py-2.5 text-sm text-stone bg-sand/40">
            Type your answer…
          </div>
        </div>
      </div>
    </motion.div>
  );
}
